import React, { useEffect, useState, useContext, useCallback, useRef } from "react";


// MUI
import { Box, Stack, Skeleton, Typography, IconButton, Avatar, SxProps } from "@mui/material";

// ICONS
import {
  VideocamTwoTone,
  PanoramaHorizontalSelectTwoTone,
  PhotoTwoTone,
  Fullscreen,
  FullscreenExit
} from "@mui/icons-material";

// CUSTOM
import DialogContext from "@/ui/DialogContext/DialogContext";
import ImageDialog from "@/views/Komentari/ImageDialog";
import Image360 from "@/views/GIS/Image360";

// Types
import { IInfoPane } from "@/@types/views/GIS/map";
import { DCRecord } from "@/@types/lib/dataController";


import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

type POIInfoMultimediaProps = {

  infoPane?: IInfoPane;

  mobile?: boolean;
};


function POIInfoMultimedia(props: POIInfoMultimediaProps) {
  const handle = useFullScreenHandle();

  const dialogContext = useContext(DialogContext);

  const [selectedPhotoTab, setSelectedPhotoTab] = useState('');
  // const [isFullscreen, setIsFullscreen] = useState(false);


  const { infoPane, mobile } = props;

  const hasPanorama = infoPane?.data.record?.panoramas && infoPane?.data.record?.panoramas !== null;
  const hasPhoto = infoPane?.data.record?.photos && infoPane?.data.record?.photos !== null;
  const hasLiveCam = infoPane?.data.record?.livecams && infoPane?.data.record?.livecams !== null;

  const panorama = Array.isArray(infoPane?.data.record?.panoramas) ? infoPane?.data.record?.panoramas[0] as DCRecord : null;
  const photo = Array.isArray(infoPane?.data.record?.photos) ? infoPane?.data.record?.photos[0] as DCRecord : null;
  const livecam = Array.isArray(infoPane?.data.record?.livecams) ? infoPane?.data.record?.livecams[0] as DCRecord : null;

  const countDifferentMultimedia = (hasPanorama ? 1 : 0) + (hasPhoto ? 1 : 0) + (hasLiveCam ? 1 : 0);
  const hasMoreThanOneMultimedia = countDifferentMultimedia > 1;

  const [containerReady, setContainerReady] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;
    const observer = new ResizeObserver(entries => {
      const { width, height } = entries[0].contentRect;
      if (width > 0 && height > 0) {
        setContainerReady(true);
      }
    });
    observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    setSelectedPhotoTab(hasPhoto ? 'photo' : hasPanorama ? 'panorama' : hasLiveCam ? 'livecam' : '');
  }, [infoPane])

  // useEffect(() => {    
    // if (isFullscreen === true && photo !== null && photo !== undefined) {
      //@ts-ignore
      // dialogContext.showDialog(ImageDialog, {
        // imagePath: photo.image_path,
        // onClose: handleDialogClose
      // }
      // )
    // }
  // }, [isFullscreen])

  // useEffect(() => {
  //   handle.enter();
  // }, [isFullscreen])


  const togglePanorma = () => {
    setSelectedPhotoTab('panorama');
  }

  const togglePhoto = () => {
    setSelectedPhotoTab('photo');
  }

  const toggleLiveCam = () => {
    setSelectedPhotoTab('livecam');
  }

  // const toggleFullscreen = () => {
  //  setIsFullscreen((prevState) => !prevState);
  // }

  const handleDialogClose = () => {
    dialogContext.hideDialog();
    // setIsFullscreen(false);
  }

  const avatarStyle: SxProps = {
    backgroundColor: "rgba(200,200,200,0.5"
  };

  const getThumbnailPath = (filepath: String) => {
    let thumbnailPath = '';
    if(filepath) {
      let parts = String(filepath).split('.');
      let extension = parts.pop();
      thumbnailPath = parts.join('.') + '_t.' + extension;
    }
    return thumbnailPath;
  }
  


  return (
    <Box ref={containerRef} sx={{ position: "relative", width: "100%", minHeight: "200px" }}>
      {selectedPhotoTab === "panorama" && panorama && containerReady ? (
        <Image360 fileName={panorama.filename as string} credits={panorama.credits as string} />
        )
          : selectedPhotoTab === 'photo' && photo ?
            
              <FullScreen handle={handle}>
                {photo.credits ? (
                  <Box sx={{
                    position: "absolute"
                    , left: "4px"
                    , top: "4px"
                    , textShadow: "1px 1px 5px #000"
                    , lineHeight: "1.4"
                  }}>
                    <Typography variant="body2" sx={{ fontSize: "12px", color: "#FFF", p: 0.5, pr: 1 }}>© {photo.credits as string}</Typography>
                  </Box>) : null}
                <img src={handle.active === true ? 'photos/' + photo.image_filepath as string : 'photos/thumbnails/' + getThumbnailPath(String(photo.image_filepath)) as string} 
                   style={{
                    objectFit: "contain",
                    width: mobile?"100%":"inherit",
                    maxWidth: "100%",
                    maxHeight: "100%",
                  }}
                />
                <Box
                sx={{
                  position: "absolute",
                  right: "10px",
                  bottom: "10px"
                }}
                >
                  {handle.active === true ? 
                  <Avatar sx={avatarStyle}>
                    <IconButton onClick={handle.exit}>
                      <FullscreenExit sx={{ transform: "scale(1.25)", color: "black" }} fontSize="medium" />
                    </IconButton>
                  </Avatar>
                  : null}
                </Box>
              </FullScreen> 
            
            : selectedPhotoTab === 'livecam' && livecam ?
              <div style={{ height: "300px", width: "400px", overflow: "hidden" }}>
                <iframe src={
                  livecam.livecam_url !== null ?
                    // @ts-ignore
                    livecam.livecam_url as string : ''
                } width={"100%"} height={"100%"} style={{ aspectRatio: "4/3", objectFit: "cover", overflow: "none", transform: "scale(2)" }} />
              </div> : null
      }
      <Box
        display={"flex"}
        width={hasPhoto && selectedPhotoTab === "photo" ? "100%" : "fit-content"}
        justifyContent={"space-between"}
        position={"absolute"}
        left={0}
        bottom={0}
        p={2}
      >
        <Stack direction="row" spacing={2}>
          {hasPanorama && hasMoreThanOneMultimedia ?
            <Avatar sx={avatarStyle}>
              <IconButton onClick={togglePanorma}>
                <PanoramaHorizontalSelectTwoTone />
              </IconButton>
            </Avatar>
            : null}
          {hasPhoto && hasMoreThanOneMultimedia ?
            <Avatar sx={avatarStyle}>
              <IconButton onClick={togglePhoto}>
                <PhotoTwoTone />
              </IconButton>
            </Avatar>
            : null}
          {hasLiveCam && hasMoreThanOneMultimedia ?
            <Avatar sx={avatarStyle}>
              <IconButton onClick={toggleLiveCam}>
                <VideocamTwoTone />
              </IconButton>
            </Avatar>
            : null}
        </Stack>
        <Box>
          {hasPhoto && selectedPhotoTab === "photo" ?
            <Avatar sx={avatarStyle}>
              <IconButton onClick={handle.enter}>
                <Fullscreen sx={{ transform: "scale(1.25)", color: "black" }} fontSize="medium" />
              </IconButton>
            </Avatar>
            : null}
        </Box>
      </Box>
    </Box>
  )
}

export default POIInfoMultimedia;
